export * from './promotion.component';